//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TableRow",
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    isOdv: {
      type: Boolean,
      default: false,
    },
    isSelf: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    rowInfo() {
      let row = {};

      if (this.row.slug_type === 'lens') {
        Object.entries(this.row).forEach(([key, value]) => {
          if (key.includes('reflection')) {
            row[key] = value;
          }
        })
      }

      return {
        brandName: this.row?.brand_name || this.row?.competitor?.brand_name || this.row?.lense?.brand_name || '',
        name: this.row?.name || this.row?.competitor?.name || this.row?.lense?.name || '',
        url: this.isOdv ? `/lenses/${this?.row?.slug || this.row.lense.slug}` : `/lenses/competitors/${this?.row?.slug || this?.row?.competitor?.slug}`,
        row: Object.keys(row).length ? row : this.row?.reflections,
        brandMaterialName: this.row?.brand_material_name || this.row?.competitor?.brand_material_name || this.row?.lense?.brand_material_name || '-'
      }
    },
  },

  methods: {
    formatPrice(price) {
      if (!price) {
        return '-'
      }

      const formatedPrice = price.replace(/[^0-9.]/g, '');
      return `${this.$numberFormat(formatedPrice)} ₽`
    }
  }
}
